var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_USER_CONTACTS, API_USER_CONTACT } from "../../api";
import axios from "axios";
export const getContacts = (api, address) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_USER_CONTACTS + address);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 400) {
                throw new Error("invalid address");
            }
        }
        throw new Error("server error");
    }
});
export const addContactItem = (api, address, data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.post(API_USER_CONTACTS + address, data);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 400) {
                throw new Error("contact already exists or invalid inputs");
            }
        }
        throw new Error("server error");
    }
});
export const getContactItem = (api, targetAddress) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_USER_CONTACT + targetAddress);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("Contact not found");
            }
        }
        throw new Error("server error");
    }
});
export const deleteContactItem = (api, targetAddress) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return (yield api.delete(API_USER_CONTACT + targetAddress));
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("Contact not found");
            }
        }
        throw new Error("server error");
    }
});
export const updateContactItem = (api, targetAddress, data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.put(API_USER_CONTACT + targetAddress, data);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("Contact not found");
            }
        }
        throw new Error("server error");
    }
});
//# sourceMappingURL=contacts.utils.js.map